import { render, staticRenderFns } from "./home.html?vue&type=template&id=e64e3708&scoped=true&external"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"
import style0 from "./home.scss?vue&type=style&index=0&id=e64e3708&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64e3708",
  null
  
)

export default component.exports